/** Drop query/hash so presigned S3 signatures are not sent to analytics or logs. */
export const stripMediaUrl = (url: string): string =>
	url.replace(/[?#].*$/, "");

const URL_IN_STRING = /https?:\/\/[^\s"'<>]+/g;

/** Replace embedded http(s) URLs in free text (e.g. console log bodies). */
export const sanitizeUrlsInString = (text: string): string =>
	text.replace(URL_IN_STRING, (url) => stripMediaUrl(url));
